import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  FaShieldAlt,
  FaUserTie,
  FaLeaf,
  FaCreditCard,
  FaUsers,
  FaHeadset
} from 'react-icons/fa';

const features = [
  {
    icon: FaShieldAlt,
    title: 'Garantia em todos os serviços',
    description: 'Qualidade e confiança em cada projeto executado',
  },
  {
    icon: FaUserTie,
    title: 'Time de profissionais capacitados',
    description: 'Equipe experiente e qualificada para seu projeto',
  },
  {
    icon: FaLeaf,
    title: 'Compromisso com o Meio Ambiente',
    description: 'Sustentabilidade e responsabilidade ecológica',
  },
  {
    icon: FaCreditCard,
    title: 'Facilidade no pagamento',
    description: 'Formas de pagamento que cabem no seu orçamento',
  },
  {
    icon: FaUsers,
    title: 'Profissionais dedicados',
    description: 'Equipe de especialistas capacitados',
  },
  {
    icon: FaHeadset,
    title: 'Rápido atendimento',
    description: 'Estamos prontos para atendê-lo',
  },
];

const FeaturesSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <section className="section-padding bg-gradient-to-br from-conforto/30 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-pattern opacity-20" />

      <div className="container-custom relative z-10">
        {/* Header */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-natureza font-semibold text-sm uppercase tracking-wider">
            Por que nos escolher
          </span>
          <h2 className="text-floresta font-display mt-4 mb-6">
            Nossos <span className="text-natureza italic">Diferenciais</span>
          </h2>
          <p className="text-jardim text-lg max-w-3xl mx-auto">
            Conquistamos clientes por todo Brasil tendo como base nossos pilares de
            Qualidade, Compromisso e Paixão!
          </p>
        </motion.div>

        {/* Features Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ y: -8, scale: 1.02 }}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-2xl transition-all duration-300 group"
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  {/* Icon */}
                  <div className="bg-gradient-to-br from-natureza to-floresta text-white w-16 h-16 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon size={28} />
                  </div>

                  {/* Content */}
                  <div>
                    <h4 className="text-floresta font-bold mb-2 group-hover:text-natureza transition-colors">
                      {feature.title}
                    </h4>
                    <p className="text-jardim text-sm leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="text-center mt-12"
        >
          <a
            href="#contato"
            className="btn-primary inline-block"
          >
            Solicite seu Orçamento
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection;
